import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { TranslatedFontSize } from '../../../theming/fontSizeTranslator';
import { maxVisibleLinksOnLargeAndXLarge } from '../../components/navigation/header/secondaryHeader/SecondaryHeader';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../partials/link/TextLink';
import { isLastLink } from '../../components/navigation/header/secondaryHeader/SecondaryLink';
import { getStyleBySize, semanticCSS } from '../../../typography/semanticTags/semanticTags.utils';
import { Span } from '../../../typography/semanticTags';
import { useTheme } from '../../../theming/useTheme';
import { NavigationLink } from '../../components/navigation/header/primaryHeader/PrimaryHeader';

const componentConfigThemeKey = 'secondaryLink';

interface AMPSecondaryLinkDataProps {
  link: NavigationLink;
  index: number;
  linksLength: number;
  pagePath: string;
}

interface AMPSecondaryLinkThemeProps {
  idleColor: string;
  activeStateColor: string;
  hoverStateColor: string;
  baseUnit: BaseUnit;
  fontSizesStyles: TranslatedFontSize;
  linkFontSizeLarge: TypographySize;
  linkFontSizeMedium: TypographySize;
  linkFontSizeSmall: TypographySize;
}

const getTextStyle = (baseUnit: BaseUnit, isActiveLink: boolean, lastLink: boolean) => {
  return StyleSheet.create({
    link: {
      width: 'max-content',
      [MEDIA_BREAKPOINTS.medium]: {
        paddingRight: lastLink ? `${baseUnit * 2}px` : 0,
      },
      [MEDIA_BREAKPOINTS.small]: {
        paddingRight: lastLink ? `${baseUnit * 2}px` : 0,
      },
    },
  });
};

export const AMPSecondaryLink: React.FunctionComponent<AMPSecondaryLinkDataProps> = props => {
  const { link, pagePath, linksLength, index } = props;
  const { activeStateColor, idleColor, hoverStateColor, baseUnit, fontSizesStyles, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall } = useTheme<AMPSecondaryLinkThemeProps>(componentConfigThemeKey);
  const { href, text } = link.link;
  const isActiveLink = href === pagePath;

  const linkStyleBasedOnScreen = linksLength > maxVisibleLinksOnLargeAndXLarge && index >= maxVisibleLinksOnLargeAndXLarge - 1
    ? {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex',
      },
    }
    : {};
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: isActiveLink ? activeStateColor : idleColor,
    activeStateColor,
    hoverStateColor: isActiveLink ? activeStateColor : hoverStateColor,
  }, linkStyleBasedOnScreen);
  const style = getTextStyle(baseUnit, isActiveLink, isLastLink(index, linksLength));
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: linkFontSizeSmall, fontSizeMedium: linkFontSizeMedium, fontSizeLarge: linkFontSizeLarge });

  return (
    <TextLinkComponent href={href} linkStyle={linkStyle}>
      <Span styles={semanticCSS(fontStyle, style.link)}>{text}</Span>
    </TextLinkComponent>
  );
};
